import { useState } from "react";
import { BookOpen, Check, ChevronDown, ChevronUp, Sparkles } from "lucide-react";

const careTips = [
  {
    bg: "bg-amber-50",
    titleColor: "text-amber-800",
    title: "• تا ۴۸ ساعت اول:",
    text: "از قرار گرفتن در معرض بخار، رطوبت زیاد و دمای بالا خودداری کنین.",
  },
  {
    bg: "bg-blue-50",
    titleColor: "text-blue-800",
    title: "• برای شست‌وشوی مژه‌ها:",
    text: "در صورت استفاده نکردن از فیکس‌کننده (اسباندر)، بعد از ۴۸ ساعت می‌تونین مژه‌ها رو بشورین. در صورت استفاده از فیکس‌کننده، تماس با آب مشکلی ندارد.",
  },
  {
    bg: "bg-green-50",
    titleColor: "text-green-800",
    title: "• بعد از ۴۸ ساعت:",
    text: "برای حفظ بهداشت و ماندگاری بیشتر، مژه‌ها رو روزی یک‌بار و به‌آرامی با فوم مخصوص چشم بشورین. (شوینده مناسب: فوم مخصوص چشم یا شامپو بچه فیروز)",
  },
  {
    bg: "bg-red-50",
    titleColor: "text-red-800",
    title: "• موارد ممنوع:",
    text: "از محصولات روغنی و پاک‌کننده‌های چرب استفاده نکنین؛ چون باعث ریزش زودتر اکستنشن میشود. از استفاده از ریمل، خط چشم مایع، دستکاری و کشیدن مژه‌ها خودداری کنین.",
  },
  {
    bg: "bg-purple-50",
    titleColor: "text-purple-800",
    title: "• ترمیم مژه‌ها:",
    text: "برای حفظ سلامت مژه‌های طبیعی، ترمیم مژه‌ها رو هر ۳ هفته و حداکثر تا ۴ هفته انجام بدین. به ازای هر هفته دیرکرد از زمان ترمیم، مبلغ ۳۰۰ هزار تومان به هزینه ترمیم اضافه می‌شود. در صورتی که برای ترمیم مراجعه کنین و بیش از ۶۰٪ مژه‌ها ریخته باشد، بسته به میزان ریزش، مبلغ ۳۰۰ تا ۵۰۰ هزار تومان به هزینه ترمیم اضافه می‌شود.",
  },
  {
    bg: "bg-teal-50",
    titleColor: "text-teal-800",
    title: "• قبل از مراجعه:",
    text: "قبل از مراجعه برای ترمیم، لطفاً با چشم‌های تمیز و بدون آرایش به سالن مراجعه کنین.",
  },
  {
    bg: "bg-slate-100",
    titleColor: "text-slate-700",
    title: "• مشکلات:",
    text: "در صورت بروز هرگونه مشکل، لطفاً تا قبل ۷ روز سریعاً به ما اطلاع بدین. در صورت نیاز، پشتیبانی از طرف آکادمی انجام شده و کار شما بدون هزینه چک می‌شه.",
  },
];

const CareBrochure = () => {
  const [open, setOpen] = useState(false);

  return (
    <section className="overflow-hidden rounded-2xl border border-purple-100 bg-white shadow-sm">
      <button
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        className="group flex w-full items-center justify-between gap-4 bg-gradient-to-l from-purple-50 via-white to-white px-4 py-4 text-right transition-colors hover:from-purple-100/70 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-purple-200 sm:px-5"
      >
        <div className="flex min-w-0 items-center gap-3">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-purple-100 text-purple-700">
              <BookOpen className="h-5 w-5" strokeWidth={2.2} />
            </span>
          <div className="min-w-0">
            <div className="flex items-center gap-1.5">
              <Sparkles className="h-3.5 w-3.5 text-purple-500" />
              <span className="text-[11px] font-semibold text-purple-500">راهنمای بعد از خدمات</span>
            </div>
            <p className="mt-0.5 text-sm font-bold text-slate-800 sm:text-base">بروشور مراقبت از مژه‌ها</p>
          </div>
        </div>
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white text-purple-500 shadow-sm ring-1 ring-purple-100 transition-transform group-hover:scale-105">
          {open ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
        </span>
      </button>
      {open && (
        <div className="border-t border-purple-50 bg-slate-50/60 p-3 sm:p-4" dir="rtl">
          <p className="mb-3 px-1 text-xs leading-relaxed text-slate-500">
            برای ماندگاری بیشتر و حفظ سلامت مژه‌ها، این نکات را رعایت کنید.
          </p>
          <div className="space-y-2">
            {careTips.map((tip, i) => (
              <article key={i} className="flex gap-3 rounded-xl border border-slate-100 bg-white p-3 shadow-[0_1px_2px_rgba(15,23,42,0.03)]">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-purple-50 text-purple-600">
                  <Check className="h-3 w-3" strokeWidth={3} />
                </span>
                <div>
                  <p className="mb-1 text-xs font-bold text-slate-800">{tip.title.replace("• ", "")}</p>
                  <p className="text-xs leading-6 text-slate-500">{tip.text}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default CareBrochure;
